module.exports = __webpack_public_path__ + "banquet/components/Banquet/images/apple-touch-icon-120.fe152c48b9917248ea3dbbb77ab1e7d9.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/Banquet/images/apple-touch-icon-120.png
// module id = 1656
// module chunks = 1